export const TAGS_GAP_SIZE = 4;
export const COUNTER_WIDTH = 32;
export const MIN_TAG_WIDTH = 44;
